import ExpandableSection from "../component/_expandableSection";

document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('body.post-type-archive-case_studies')) {
        new ExpandableSection('.js-cs-filter-group-main', '.js-cs-filter-group-title-wrapper', '.js-cs-list-wrapper', '.js-cs-title-chevron', false, true, false, false);

        const loadMoreButton = document.getElementById('js-cs-load-more-case-studies');
        const clearFiltersButton = document.querySelectorAll('.js-cs-clear-filters');
        const container = document.getElementById('js-cs-container');
        const contentContainer = document.querySelector('.js-cs-content');
        const sidebarContainer = document.querySelector('.js-cs-sidebar');
        const clearButtonsContainers = document.querySelectorAll('.js-cs-clear-filters-wrapper');
        const actionButtonsContainer = document.querySelector('.js-cs-page-action-wrapper');
        let page = 1;
        let maxPages = 1;

        // Funkcja do fetchowania i aktualizacji case studies na podstawie filtrów
        async function fetchCaseStudies(filters = {}) {
            // Dodaj klasę is-loading przed rozpoczeciem zapytania
            if (contentContainer && sidebarContainer) {
                setTimeout(() => {
                    contentContainer.classList.add('is-loading');
                    sidebarContainer.classList.add('is-loading');
                }, 300);
            }

            try {
                const response = await fetch(ajax_obj.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: new URLSearchParams({
                        action: 'filter_case_studies',
                        filters: JSON.stringify(filters),
                        page: page
                    })
                });
                const result = await response.json();

                if (container) {
                    if (page === 1) {
                        container.innerHTML = result.html;
                    } else {
                        container.insertAdjacentHTML('beforeend', result.html);
                    }
                    // Aktualizuj tagi w menu bocznym
                    updateSidebarTags(result.tags_availability);

                    // Aktualizuj maxPages na podstawie odpowiedzi z serwera
                    maxPages = result.max_pages;

                    // Kontroluj widoczność przycisku Load More
                    if (page >= maxPages) {
                        actionButtonsContainer.style.display = 'none';
                        loadMoreButton.style.display = 'none';
                    } else {
                        actionButtonsContainer.style.display = 'flex';
                        loadMoreButton.style.display = 'block';
                    }
                } else {
                    console.error('Error: Case studies container not found.');
                }
            } catch (error) {
                console.error('Error fetching case studies:', error);
            } finally {
                // Usuń klasę is-loading po zakończeniu zapytania
                if (contentContainer && sidebarContainer) {
                    setTimeout(() => {
                        contentContainer.classList.remove('is-loading');
                        sidebarContainer.classList.remove('is-loading');
                    }, 500);
                }
            }
        }

        // Funkcja do aktualizacji menu bocznego
        function updateSidebarTags(tagsAvailability) {
            const allTagCheckboxes = document.querySelectorAll('.js-cs-form-check-input[name="tags"]');

            allTagCheckboxes.forEach((checkbox) => {
                const tagSlug = checkbox.value;
                const parentElement = checkbox.parentElement;
                if (tagsAvailability[tagSlug]) {
                    checkbox.disabled = false;
                    parentElement.classList.remove('disabled');
                } else {
                    checkbox.disabled = true;
                    checkbox.checked = false;
                    parentElement.classList.add('disabled');
                }
            });
        }

        // Funkcja do parsowania parametrów URL
        function getUrlParameter(name) {
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
            const results = regex.exec(window.location.href);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        // Sprawdź, czy w URL jest parametr filter i zaznacz odpowiedni checkbox
        const initialFilterTag = getUrlParameter('filter');
        if (initialFilterTag) {
            const matchingCheckbox = document.querySelector(`.js-cs-form-check-input[name="tags"][value="${initialFilterTag}"]`);
            if (matchingCheckbox) {
                matchingCheckbox.checked = true;
                const selectedTags = [initialFilterTag];
                const filters = {
                    tags: selectedTags
                };
                fetchCaseStudies(filters);
                clearButtonsContainers.forEach((buttonContainer) => {
                    buttonContainer.classList.remove('d-none');
                });
            }
        } else {
            // Jeśli nie ma filtra, pobieramy case studies na starcie
            fetchCaseStudies();
        }

        // Obsługa zmian filtrów po kliknięciu checkboxa
        document.querySelectorAll('.js-cs-form-check-input[name="tags"]').forEach((checkbox) => {
            checkbox.addEventListener('change', function () {
                page = 1;
                const selectedTags = [];
                document.querySelectorAll('.js-cs-form-check-input[name="tags"]:checked').forEach((checkedBox) => {
                    selectedTags.push(checkedBox.value);
                });
                const filters = {
                    tags: selectedTags
                };
                fetchCaseStudies(filters);
                if (selectedTags.length > 0) {
                    clearButtonsContainers.forEach((buttonContainer) => {
                        buttonContainer.classList.remove('d-none');
                    });
                } else {
                    clearButtonsContainers.forEach((buttonContainer) => {
                        buttonContainer.classList.add('d-none');
                    });
                }
            });
        });

        // Obsługa przycisku "Wyczyść filtry"
        clearFiltersButton.forEach((clearButton) => {
            clearButton.addEventListener('click', function () {
                const url = new URL(window.location);
                url.searchParams.delete('filter');
                history.replaceState({}, '', url.toString());
                document.querySelectorAll('.js-cs-form-check-input[name="tags"]:checked').forEach((checkbox) => {
                    checkbox.checked = false;
                });
                page = 1;
                fetchCaseStudies();
                clearButtonsContainers.forEach((buttonContainer) => {
                    buttonContainer.classList.add('d-none');
                });
            });
        });

        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', function () {
                page++;
                const selectedTags = [];
                document.querySelectorAll('.js-cs-form-check-input[name="tags"]:checked').forEach((checkbox) => {
                    selectedTags.push(checkbox.value);
                });
                fetchCaseStudies({
                    tags: selectedTags
                });
            });
        }

        // Opcjonalnie: Sprawdzenie na wstępnym załadowaniu, czy przycisk powinien być widoczny
        // W powyższej modyfikacji, jeżeli nie ma ustawionego filtra w URL, wykonujemy fetchCaseStudies() już przy ładowaniu strony,
        // co pozwala ustawić widoczność przycisku "Load More" w zależności od wartości max_pages.
    }
});
